import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function useRequireAuth() {
  const LocalBasePath = "sidenav";
  let location: any = useLocation();

  const Context: any = useAuth();
  function RequireAuth({ children }: { children: JSX.Element }) {
    if (!Context?.userType) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return children;
  }
  return RequireAuth;
}
